import styled from "styled-components"
import {Row, Col} from "@irati/ui/src/Layout"
import {hoverRaise} from "@irati/ui/src/global/css/animations"

export const StyledDeal = styled.div`
  overflow: hidden;
  margin: ${({theme}) => `${theme.spacing.half} 0px ${theme.spacing.oneAndHalf}`};
  border-radius: ${({theme}) => theme.border.radius.extraLarge};
  ${hoverRaise}

  a {
    text-decoration: none;

    :hover {
      color: black;
    }
  }
`

export const StyledRow = styled(Row)`
  margin: 0;
`

export const StyledCol = styled(Col)`
  padding: 0;
`
